import React from 'react';
import { ImageCollage } from '@naf-simba/sections-image-collage';
import styled from '@emotion/styled';
import { isNonNullable } from '@lib/isNonNullable';
import { CloudinaryImageType } from '../../../../../../../types/CloudinaryImageType';
import { useCloudinary } from '../../../../../hooks/Cloudinary/useCloudinary';

interface Props {
  images?: CloudinaryImageType[];
}
const BlockImageCollage = ({ images }: Props) => {
  const { getProcessedImage } = useCloudinary();

  const mappedImages = images
    ?.map((image: CloudinaryImageType, index: number) => {
      const imageHeight = index === 0 ? 530 : 260;
      const cloudinaryImageSrc = getProcessedImage(image?.publicId || image?.public_id, {
        height: imageHeight,
        focusMethod: image?.focus,
      })?.toURL();

      if (cloudinaryImageSrc) {
        return {
          src: cloudinaryImageSrc,
          description: image.caption ? image.caption : '',
          altText: image.altText || '',
        };
      }
      return null;
    })
    .filter(isNonNullable);

  return (
    <ImageCollageWrapper className="BlockImageCollage">
      <ImageCollage images={mappedImages} />
    </ImageCollageWrapper>
  );
};

const ImageCollageWrapper = styled.div`
  margin-top: 64px;
  margin-bottom: 58px;
  p {
    max-width: 100%;
  }
`;

export default BlockImageCollage;
